module.exports = __webpack_public_path__ + "static/media/buy_request_details_make_1.f17410c5.png";